import PropTypes from "prop-types";
import { css } from "@emotion/react";

import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Menu } from "antd";
import { useHistory } from "react-router-dom";

import { clearAuthTokens } from "axios-jwt";

import { resetUser } from "@/store/user";

Avatar.propTypes = {};

function Avatar() {
  const dispatch = useDispatch();

  const contextRef = useRef();
  const history = useHistory();

  const user = useSelector((state) => state.user);

  const handleLogout = () => {
    //JWT 토큰 사용시 처리
    clearAuthTokens();
    localStorage.removeItem("login");
    dispatch(resetUser());

    history.push("/auth");
  };

  const Context = (
    <Menu css={context}>
      <Menu.Item key="3" onClick={handleLogout}>
        Sign out
      </Menu.Item>
    </Menu>
  );

  return (
    <div ref={contextRef}>
      <Dropdown
        overlay={Context}
        getPopupContainer={() => contextRef.current}
        trigger={["click"]}
      >
        <div css={avatar}>
          <img src="/images/image-avatar.png" alt="" />
        </div>
      </Dropdown>
    </div>
  );
}

const avatar = (theme) => css`
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 28px;
  height: 28px;
  border: 1px solid #eaeaea;
  background: #eaeaea;
  border-radius: 50%;
  font-size: 0;
`;

const context = (theme) => css`
  margin-top: 8px;
`;

export default Avatar;
